import { createReducer, on } from '@ngrx/store';
import { DropdownData } from '@zayan-erp/shared';
import * as SalesActions from './sales.actions';

export interface LotLookup {
  id: string;
  lotNo: string;
}

export interface ProjectLotsState {
  projectId: string | null;
  lots: LotLookup[];
  loaded: boolean;
}

export interface SalesState {
  salesOffices: DropdownData[];
  agencies: DropdownData[];
  salesOfficesPublic: DropdownData[];
  salesAgents: DropdownData[];
  agencyRealtors: DropdownData[];
  projectLots: ProjectLotsState;
}

export const initialSalesState: SalesState = {
  salesOffices: [],
  agencies: [],
  salesOfficesPublic: [],
  salesAgents: [],
  agencyRealtors: [],
  projectLots: { projectId: null, lots: [], loaded: false }
};

export const salesReducer = createReducer(
  initialSalesState,
  on(SalesActions.loadSalesOfficesSuccess, (state, { salesOffices }) => ({
    ...state,
    salesOffices
  })),
  on(SalesActions.loadAgenciesSuccess, (state, { agencies }) => ({
    ...state,
    agencies
  })),
  on(SalesActions.loadSalesOfficesPublicSuccess, (state, { salesOffices }) => ({
    ...state,
    salesOffices: salesOffices, // Also populate salesOffices for ERP app
    salesOfficesPublic: salesOffices
  })),
  on(SalesActions.loadSalesAgentsSuccess, (state, { salesAgents }) => ({
    ...state,
    salesAgents
  })),
  on(SalesActions.loadAgencyRealtorsSuccess, (state, { agencyRealtors }) => ({
    ...state,
    agencyRealtors
  })),
  on(SalesActions.loadSalesProjectLotsSuccess, (state, { projectId, lots }) => ({
    ...state,
    projectLots: { projectId, lots, loaded: true }
  })),
  on(SalesActions.loadSalesProjectLotsFailure, (state, { projectId }) => ({
    ...state,
    projectLots: { projectId, lots: [], loaded: true }
  }))
);
